import React from 'react';
import {connect} from 'react-redux';
import Message from '../../../components/message/index';
import { getAdminUserList } from '../../../actions/actions';

class AdminUserList extends React.Component {
    constructor(props)
    {
        super(props);
        this.state = {
            users: [],
            selectedUser: null,
            searchText: null,
            tempUserList: []
        }
        this.getUserList();
    }

    getUserList() {
        getAdminUserList((data) => {

            this.setState({
                users: data.users,
            })
        });
    }
    
    handleItemClick(index){
        this.setState({selectedUser: this.state.users[index]});
    }

    handleSearch(e)
    {
       if(e.target.value != null && e.target.value != "") {
           if(this.state.tempUserList.length === 0) {
               this.setState({tempUserList: this.state.users, users: this.state.users.filter(user => user.userName.toLowerCase().includes(e.target.value.toLowerCase()))});
           } else {
                this.setState({users: this.state.tempUserList.filter(user => user.userName.toLowerCase().includes(e.target.value.toLowerCase()))});
           }
       } else {
        this.setState({users: this.state.tempUserList, tempUserList: []});
       }
    }
    

    render() {
       

        return (
        [
            <section className="panel">
            <Message />
            <div className="container">
                <div className="table">
                    <div className="top">
                        <div className="title-default">
                            Kullanıcı Listesi
                        </div>
                        <div className="actions"></div>
                    </div>
                    <div className="bottom">
                        <div className="table-container">
                        <div className="form-item" style={{margin: '20px'}}>
                                <label>Müşteri Ara</label>
                                <input type="text" placeholder="Kullanıcı araması yapınız" value={this.state.searchText} onChange={this.handleSearch.bind(this)} />
                            </div>
                            <table className="sortable">
                                <thead>
                                    <tr>
                                        <th><span>Kullanıcı Adı</span></th>
                                        <th><span>Kullanıcı Email</span></th>
                                        <th><span>Role</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.users && this.state.users.map((item, i) => {
                                        return (
                                            <tr onClick={() => { this.props.history.push('/admin/user-list/detail/' + item.userId,{user: item}) }}>
                                                <td>{item.userName}</td>
                                                <td>{item.userEmail}</td>
                                                <td>{item.userRole}</td>
                                            </tr>
                                            
                                        )
                                    }
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        ]
      );
    }
  }

  function mapStateToProps(state) {
      return {
          app: state.app 
      }
  }

  export default connect(mapStateToProps)(AdminUserList)